import { CheckCircle } from "@phosphor-icons/react";

const Facility = () => {
  return (
    <section
      id="facility"
      className="py-24 sm:py-32 bg-white"
      data-testid="facility-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 max-w-3xl">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#0B2F6B]">
            Our Facility
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-[#1A1A2E]">
            Real Equipment. Real Expertise.
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Take a look inside our shop. We maintain a full inventory of
            Sciton, Cutera, and other premium laser systems — ready for
            service, restoration, or resale.
          </p>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
          {/* Large image - inventory */}
          <div className="overflow-hidden bg-slate-50">
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_laser-repair-hub/artifacts/f9o4ewzv_IMG_20260817_102852.webp"
              alt="Sciton Joule laser equipment inventory at John Laser Division"
              className="w-full h-[400px] lg:h-[500px] object-cover"
              data-testid="facility-image-inventory"
            />
          </div>

          {/* Close up image */}
          <div className="overflow-hidden bg-slate-50">
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_laser-repair-hub/artifacts/4r42e73t_IMG_20260817_102851.webp"
              alt="Sciton Joule laser device close up"
              className="w-full h-[400px] lg:h-[500px] object-cover"
              data-testid="facility-image-closeup"
            />
          </div>
        </div>

        {/* Trust Points */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-slate-200">
          {[
            {
              title: "Full In-Stock Inventory",
              description: "Ready-to-service systems on hand at all times",
            },
            {
              title: "Professional Workshop",
              description: "Dedicated space for diagnostics and repair",
            },
            {
              title: "Every Unit Tested",
              description: "Rigorous quality control before delivery",
            },
          ].map((item) => (
            <div key={item.title} className="flex gap-3">
              <CheckCircle
                weight="fill"
                className="w-6 h-6 text-[#1E88FF] flex-shrink-0 mt-1"
              />
              <div>
                <h3 className="font-semibold text-[#1A1A2E]">{item.title}</h3>
                <p className="text-sm text-slate-600 mt-1">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facility;
